export const abatementChart = {
    seriesAbatement: [{
            name: "Abatement (tCO2-e) - total",
            type: "column",
            data: [],
            color: "#78BE20",
        }, {
            name: "Abatement (tCO2-e) - month",
            type: "column",
            data: [],
            color: "#DDF0AC",
        },

        {
            name: "Abatement per MWh",
            type: "line",
            data: [],
            color: "#E73B30",
        },
    ],
    chartOptionsAbatement: {
        chart: {
            height: 350,
            type: "line",
            stacked: true,
            zoom: {
                enabled: false,
            },
            background: "#0D3937",  // set to dark: allow clear to display in export png
            //
            toolbar: {
                show: true,
                tools: {
                  // replace default dropdown icons with custom ones:
                  download: false,
                },
              },
            //
            
        },
        plotOptions: {
            bar: {
                borderRadius: 1, // bar corner radius to 1: original design is 1
                // borderRadiusApplication: "end",
                horizontal: false,
                dataLabels: {
                    position: "top",
                },
            },
        },
        stroke: {
            width: [2, 2, 4],
            color: ["transparent", "transparent", "#E73B30"],
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [2],
        },
        labels: [],
        xaxis: {
            // type: "datetime",
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                },
                rotate: -45,
                hideOverlappingLabels: false,
            },
            tooltip: {
                enabled: false,
            }
            // labelPlacement: 'onTicks',
        },
        yaxis: [
            {
                seriesName: 'Abatement (tCO2-e) - total',
                show: false
            }, 
            
            {
                seriesName: 'Abatement (tCO2-e) - total',
                decimalsInFloat: 0,
                title: {
                    text: "Abatement (tCO2-e)",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },

            {
                seriesName: 'Abatement per MWh',
                opposite: true,
                decimalsInFloat: 4,
                title: {
                    text: "Abatement per MWh",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },
        ],
        // yaxis: ,
        legend: {
            position: "top",
            horizontalAlign: "left",
            fontFamily: "Moderat",
            fontSize: "14px",
            labels: {
                colors: "#FFFFFF",
            },
            markers: {
                fillColors: ["#78BE20", "#DDF0AC", "#E73B30"],
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            enabled: true,
            enabledOnSeries: [0,1,2],
            shared: true,
            followCursor: false,
            intersect: false,
            inverseOrder: false,
            custom: undefined,
            hideEmptySeries: true,
            fillSeriesColor: false,
            theme: "light",
            style: {
              fontSize: '14px',
              fontFamily: "Moderat",
              
            },
            onDatasetHover: {
                highlightDataSeries: false,
            },
            x: {
                show: true,
                format: 'mm YY',
                formatter: undefined,
            },
            y: {
                formatter: undefined,
                title: {
                    formatter: (seriesName) => seriesName,
                },
            },
            z: {
                show: false,
                formatter: undefined,
                title: 'Size: '
            },
            marker: {
                show: true,
            },
        }
    },


    seriesHistory: [{
        // data: [400, 83, 93, 156],
        name: 'Value ',
        data: [0, 0, 0, 0],
    }, ],
    chartOptionsHistory: {
        chart: {
            type: "bar",
            height: 350,
            background: "#0D3937", 
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 1,
                // borderRadiusApplication: "end",
                horizontal: true,
                distributed: true,
            },
        },
        colors: ["#78BE20", "#DDF0AC", "#A6BBC8", "#F0EFEB"],
        dataLabels: {
            enabled: false,
        },
        grid: {
            xaxis: {
              lines: {
                show: true
              }
            },
            yaxis: {
                lines: {
                  show: false
                }
              }
          },
        xaxis: {
            categories: [
                "Current",
                ["Under", "audit"],
                ["Issue", "requested"],
                "Issued",
            ],
            labels: {
                style: {
                    colors: "#ffffff",
                    fontFamily: "Moderat",
                },
                hideOverlappingLabels: true,
            },
        },
        yaxis: {
            title: {
                text: "",
                style: {
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: 700,
                    fontFamily: "Moderat",
                },
            },
            labels: {
                style: {
                    colors: "#ffffff",
                    fontFamily: "Moderat",
                },
            },
        },
        legend: {
            show: false,
        },
        fill: {
            opacity: 1
        },
        // tooltip: {
        //     y: {
        //         formatter: function (value) {
        //             return `${value}`; // فقط مقدار نمایش داده شود
        //         },
        //     },
        //     custom: function ({
        //         series,
        //         seriesIndex,
        //         dataPointIndex,
        //         w
        //     }) {
        //         const category = w.globals.labels[dataPointIndex];
        //         const value = series[seriesIndex][dataPointIndex];
        //         return `<div style="padding:5px; color: white; background: rgba(0, 0, 0, 0.7); border-radius: 5px;">
        //                 ${category}: ${value}
        //             </div>`;
        //         // return `<div class="apexcharts-tooltip apexcharts-theme-light apexcharts-active" style="left: 50.0781px; top: 206.118px;">
        //         //             <div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;"> ${category} </div>
        //         //             <div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">
        //         //                 <span class="apexcharts-tooltip-marker" style="background-color: rgba(240, 239, 235, 0.85);"></span>
        //         //                 <div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">
        //         //                     <div class="apexcharts-tooltip-y-group">
        //         //                         <span class="apexcharts-tooltip-text-y-label"> </span>
        //         //                         <span class="apexcharts-tooltip-text-y-value"> ${value} </span>
        //         //                     </div>
        //         //                     <div class="apexcharts-tooltip-goals-group">
        //         //                         <span class="apexcharts-tooltip-text-goals-label"></span>
        //         //                         <span class="apexcharts-tooltip-text-goals-value"></span>
        //         //                     </div>
        //         //                     <div class="apexcharts-tooltip-z-group">
        //         //                         <span class="apexcharts-tooltip-text-z-label"></span>
        //         //                         <span class="apexcharts-tooltip-text-z-value"></span>
        //         //                     </div>
        //         //                 </div>
        //         //             </div>
        //         //         </div>`;
        //     }
        // },

        // tooltip: {
        //     y: {
        //         formatter: function (value) {
        //             return `${value}`; // فقط مقدار نمایش داده شود
        //         },
        //     },
        //     custom: function ({
        //         series,
        //         seriesIndex,
        //         dataPointIndex,
        //         w
        //     }) {
        //         const category = w.globals.labels[dataPointIndex];
        //         const value = series[seriesIndex][dataPointIndex];
        //         return `<div style="padding:5px; color: white; background: rgba(0, 0, 0, 0.7); border-radius: 5px;">
        //                 ${category}: ${value}
        //             </div>`;
        //     }
        // },
    },

    newSeriesHistory_issued: [0, 0, 0],

    newChartOptionsHistory_issued: {
        chart: {
            type: 'donut',
        },
        labels: ["Pending Sale", "Sold", "Retired"],
        colors: ['#78BE20', '#DDF0AC', '#C9D6DE'],
        plotOptions: {
            pie: {
                donut: {
                    size: '55%',
                    labels: {
                        show: true,
                        name: {
                          show: false,
                        },
                        value: {
                          show: true,
                          fontSize: '14px',
                          fontFamily: 'Helvetica, Arial, sans-serif',
                          fontWeight: 400,
                          color: '#ffffff',
                          offsetY: 0,
                          formatter: function () {
                            let result = "Credits Issued";
                                return result;
                            }
                        },
                        total: {
                            show: true,
                            fontSize: '14px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 400,
                            color: '#ffffff',
                            offsetY: 0,
                            formatter: function () {
                              let result = "Credits Issued";
                                  return result;
                              }
                        }
                      }
                }
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ['#0d3937']
            },
            dropShadow: {
                enabled: false
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex];
            }
        },
        legend: {
            show: true,
            position: 'right',
            offsetY: 40,
            offsetX: 20,
            horizontalAlign: 'left',
            labels: {
                colors: '#ffffff', // Set the legend text color to white
                fontSize: '12px',
                fontFamily: 'Moderat',
                fontWeight: 400,
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 300
                },
            }
        }],
    },

    newSeriesHistory_issued_mobile: [
        {
            name: 'Pending Sale',
            data: [0]
        }, 
        {
            name: 'Sold',
            data: [0]
        }, 
        {
            name: 'Retired',
            data: [0]
        }
    ],

    newChartOptionsHistory_issued_mobile: {
        chart: {
            type: 'bar',
            height: 40,
            stacked: true,
            // stackType: '100%',
            toolbar: {
                show: false
            }
        },
        labels: ["Pending Sale", "Sold", "Retired"],
        colors: ['#78BE20', '#DDF0AC', '#C9D6DE'],
        plotOptions: {
            bar: {
              horizontal: true,
            //   borderRadius: 10,
            //   borderRadiusApplication: 'end',
            //   borderRadiusWhenStacked: 'last'
            },
          },
        stroke: {
            width: 2,
            colors: ['#0D3937']
          },
          title: {
            text: 'Credit Issues',
            offsetY: 15,
            offsetX: 15,
            style: {
                color: '#ffffff',
                fontSize: '12px',
                fontFamily: 'Moderat',
                fontWeight: 400,
            }

          },
          axisTicks: { 
            show: false 
          },
          xaxis: {
            show: false,
            categories: [""],
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: {
              show: false
            }
          },
          yaxis: {
            show: true,
            color: '#ffffff',
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: {
              show: true,
              style: {
                colors: '#ffffff',
                fontSize: '12px',
                fontFamily: 'Moderat',
                fontWeight: 400
              }
            }
          },
          grid: {
            show: false
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + "K"
              }
            }
          },
          fill: {
            opacity: 1
          
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'left',
            offsetX: -5,
            labels: {
              colors: '#ffffff'
            }
          }
    },

}